import { ListBox } from "primereact/listbox";

export const Admin = () => {
  const options = [
    { label: "Contexts", value: "context" },
    { label: "Fields", value: "fields" },
    { label: "Campus Activities", value: "campus-activities" },
    { label: "People Connection", value: "people-connection" },
    { label: "Story Interactions", value: "story-interactions" },
    { label: "Voice Requests", value: "voice-requests" },
  ];

  return (
    <div className="col-12 md:col-3">
      <ListBox options={options} />
    </div>
  );
};
